// extracted by mini-css-extract-plugin
export default {"field":"UserEmailEditStep_field__S698m","text":"UserEmailEditStep_text__KxLk5"};